import axios from "axios";

const axiosInstance = axios.create({
  baseURL: `https://api.pagosbucarelly.com/api`,
  // baseURL: `http://localhost:8000/api`,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.response.use(
  (response) => response, // Si la respuesta es correcta, simplemente la retorna
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("userDetails");
      window.location.href = "/"; // Redirigir al login
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
